import { ActivatedRoute } from '@angular/router';
import { TabViewComponent } from 'ngx-lib';
import { TabNames } from '../models/enums/TabNames';

const normalizedTabs = Object.keys(TabNames)
    .filter((key) => isNaN(Number(key)))
    .reduce(
        (acc, tabName) => {
            acc[tabName.toLowerCase().replaceAll(' ', '')] = tabName;
            return acc;
        },
        {} as Record<string, string>
    );

export function getTab(key: string | null): string | undefined {
    if (!key) return undefined;
    const normalizedKey = key.toLowerCase().replaceAll(' ', '');
    return normalizedTabs[normalizedKey];
}

export function processTabParameter(
    route: ActivatedRoute,
    tabControl: TabViewComponent,
    defaultTab = 'Overview'
): string {
    const paramTabName = route.snapshot.paramMap.get('tab') ?? '';
    const tabs = tabControl.getTabsNames();

    const normalizedParamTabName = paramTabName.toLowerCase().replace(/\s+/g, '');
    const normalizedTabsNames = tabs.map((tab) => tab.toLowerCase().replace(/\s+/g, ''));

    const matchingTabIndex = normalizedTabsNames.findIndex((x) => x.includes(normalizedParamTabName));

    return matchingTabIndex !== -1 ? tabs[matchingTabIndex] : defaultTab;
}
